var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"simple-message-container"},[_c('div',{staticClass:"simple-message-avatar"},[_c(_setup.Avatar,{attrs:{"url":_setup.props.avatar}})],1),_c('div',[_c('div',{staticClass:"simple-message-sender"},[_vm._v(" "+_vm._s(_setup.props.sender)+" ")]),_c('div',{staticClass:"simple-message-body"},[_c('div',{class:{
          'simple-message-content': true,
          'no-padding': _setup.isNoPadding
        }},[_vm._t("default")],2),_c('div',{staticClass:"timestamp"},[_vm._v(" "+_vm._s(_setup.calculateTimestamp(_setup.props.time*1000))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }